import { render, staticRenderFns } from "./AutomaticEvents.vue?vue&type=template&id=56484bd9"
import script from "./AutomaticEvents.vue?vue&type=script&lang=ts"
export * from "./AutomaticEvents.vue?vue&type=script&lang=ts"
import style0 from "./AutomaticEvents.vue?vue&type=style&index=0&id=56484bd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports